import { DrawerConstant } from '../constants'
import { DrawerConstant as DrawerConstantV3 } from '../v3/constants'

const initialState = {
  drawerState: 'drawerMainMenu',
  opened: true,
  titleClass: 'AutoHostingClass',
  collapsed: false,
  currentChallenge: 1,
  availabilityData: {
    availabilityObj: {}
  },
  drawerMobileOpen: false,
  exitVetsmith: false
}

export default function drawer (state = initialState, action) {
  switch (action.type) {
    case DrawerConstant.COLLAPSE_DRAWER:
      return {
        ...state,
        drawerState: action.payload.drawerState,
        opened: action.payload.opened,
        titleClass: action.payload.titleClass,
        collapsed: action.payload.collapsed,
        drawerMobileOpen: false,
      };
    case DrawerConstant.SET_CURRENT_CHALLENGE:
      return {
        ...state,
        currentChallenge: action.payload.currentChallenge
      };
    case DrawerConstant.SET_AVAILABILITY_OBJECT: {
      /* FIX SOME SCENARIOS THE AVAILABILITY BUTTON NOT REFRESH
      THE CURRENT REFRESH MECHANISM IS TOO UNNECESSARY COMPLEX FOR THE NavigationDrawer 
      THERE ARE 3 PLACES WHICH STORE USER AVAILABILITY IN LOCAL STORAGE:
      - drawer
      - profile
      - dashboard
      */
      let set_availability_count = state.availabilityData ? state.availabilityData.set_availability_count || 0 : 0;
      set_availability_count++;

      return {
        ...state,
        availabilityData: { ...state.availabilityData, ...action.payload, set_availability_count }
      }
    }
    case DrawerConstantV3.DRAWER_MOBILE_TOGGLE:
      return {
        ...state,
        drawerMobileOpen: !state.drawerMobileOpen,
      }

    case DrawerConstantV3.EXIT_VETSMITH:
      return {
        ...state,
        exitVetsmith: action.payload,
      }
    default:
      return state;
  };
};
